<template>
  <div id="sub-ship">
 
    <!-- ======================== 히어로 캐러셀 ======================== -->
    <section class="sub-main">
      <div id="carouselSubIndicators" class="carousel slide" data-bs-ride="carousel" data-bs-touch="true" data-bs-interval="3000">
        <div class="carousel-indicators">
          <button type="button" data-bs-target="#carouselSubIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselSubIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../assets/img/ships/pukwanF.jpg" class="d-block w-100 hero-img" alt="부관훼리" v-if="this.mobileDisplay || this.isApp">
            <img src="../assets/img/ships/pukwanF.jpg" class="d-block w-100 hero-img hero-img-pc" alt="부관훼리" v-else>
            <div class="carousel-caption hero-caption">
              <div class="caption-inner">
                <span class="caption-tag">PUKWAN FERRY · 부관훼리</span>
                <h5>유서깊은 국내 최초의 한일여객선 부관훼리</h5>
                <p>부관훼리를 타고 시모노세키까지 안전하고 시원하게!</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <img src="../assets/img/ships/camelliaF.jpg" class="d-block w-100 hero-img" alt="카멜리아" v-if="this.mobileDisplay || this.isApp">
            <img src="../assets/img/ships/camelliaF.jpg" class="d-block w-100 hero-img hero-img-pc" alt="카멜리아" v-else>
            <div class="carousel-caption hero-caption">
              <div class="caption-inner">
                <span class="caption-tag">CAMELLIA LINE · 카멜리아</span>
                <h5>부산과 후쿠오카를 연결하는 화객선 카멜리아</h5>
                <p>가까운 후쿠오카까지 최고의 바다여행을 즐겨보세요!</p>
              </div>
            </div>
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselSubIndicators" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselSubIndicators" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </section>
 
    <!-- 웨이브 구분선 -->
    <div class="wave-divider">
      <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0,30 C240,60 480,0 720,30 C960,60 1200,0 1440,30 L1440,60 L0,60 Z" fill="#f0f7ff"/>
      </svg>
    </div>
 
    <!-- ======================== 일본 선박 상품 ======================== -->
    <section id="pack" class="packages">
      <div class="container">
        <div class="packages-content">
          <div class="row gx-4">
 
            <!-- 섹션 타이틀 -->
            <div class="sub-title">
              <div class="title-deco">
                <i class="bi bi-water"></i>
              </div>
              <span class="st-main">일본 선박</span>
              <span class="st-sub">일본행 선박, 엔타비에서 가장 저렴하게!</span>
            </div>
 
            <!-- 카테고리 필터 -->
            <div class="category">
              <ul>
                <li key="jpAll" @click="showJpSelArea('jpAll')" class="fingerPointer">
                  <a href="javascript: void(0)">전체</a>
                </li>
                <li :key="dtCd" v-for="(etc, dtCd) in this.spToDt" @click="showJpSelArea(etc[0].dtCd)" class="fingerPointer">
                  <a href="javascript: void(0)">{{ etc[0].DT }}</a>
                </li>
              </ul>
            </div>
 
            <!-- 상품 카드 -->
            <div class="col-lg-4 col-md-6 col-sm-12 mb-5" :key="i" v-for="(nd, i) in this.ndaytirpList_jp">
              <div class="text-decoration-none link-dark">
                <div class="package-item">
                  <div class="pic" @click="goToDetail(nd.pdtCode, nd.salesRoute)" style="cursor: pointer">
                    <div class="packages-hover">
                      <div class="packages-hover-content">
                        <span class="hover-cta">승선권 보기 <i class="bi bi-arrow-right"></i></span>
                      </div>
                    </div>
                    <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img-top" alt="..." />
                    <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top" />
 
                    <!-- 항로 배지 -->
                    <div class="route-chip">
                      <i class="bi bi-arrow-left-right"></i> 부산 ↔ 일본
                    </div>
 
                    <div class="badge">
                      <div v-if="nd.badgeFlag === 'Y'">
                        <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                      </div>
                      <div v-if="nd.badge2Flag === 'Y'">
                        <div v-if="nd.badgeFlag != 'Y'" class="badge1"><small class="badge1-text">{{ nd.badge2 }}</small></div>
                        <div v-else class="badge2" style="margin-left: 180px;"><small class="badge2-text">{{ nd.badge2 }}</small></div>
                      </div>
                      <div v-else></div>
                    </div>
                  </div>
 
                  <div class="package-item-txt">
                    <div class="pdtName">{{ nd.pdtNameKor }}</div>
                    <div class="pdtRemarks">
                      <i class="bi bi-tsunami"></i> {{ nd.pdtRemarks }}
                    </div>
                    <div class="card-divider"></div>
                    <div class="price">
                      <div class="priceSection">
                        <div>
                          <!-- 가격 표시 -->
                          <div class="my-1 d-flex align-items-center flex-wrap price-row"
                               v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'"
                               @click="goToDetail(nd.pdtCode, nd.salesRoute)" style="cursor: pointer;">
                            <b class="fs-4 fw-bolder ndayPrice" v-if="nd.discountPercent == 0">
                              {{ getCurrencyFormat(nd.pdtPrice) }} <span class="price-won">원</span>
                            </b>
                            <template v-else>
                              <b class="text-muted text-decoration-line-through me-2 ndayPrice original-price">
                                {{ getCurrencyFormat(nd.pdtPrice) }}원
                              </b>
                              <i class="bi bi-caret-right-fill text-muted" style="font-size:.8rem"></i>
                              <span class="mx-2 ndayPrice discount-rate">
                                {{ getCurrencyFormat(nd.discountPercent) }}%
                              </span>
                              <span class="ndayPrice fs-4 fw-bolder final-price">
                                {{ getCurrencyFormat((nd.basic_PdtPrice * 1) + (nd.minOptPrice * 1)) }}
                              </span>
                              <span class="price-won"> 원~</span>
                            </template>
                          </div>
                          <!-- 준비중 -->
                          <div class="my-1 d-flex align-items-center preparing-wrap" v-else>
                            <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                            <span class="ndayPrice preparing-text">상품을 준비 중입니다</span>
                            <i class="bi bi-question-circle-fill text-danger"
                               style="cursor: pointer; padding-left: 5px; font-size:.9rem"
                               data-bs-toggle="tooltip" data-bs-placement="top"
                               title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요"
                               @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
            <!-- 더보기 -->
            <div class="more-wrap more-jp justify-content-center fingerPointer"
                 @click="showJpMoreList()"
                 v-if="this.ndaytirpList_jp_more.length > 0">
              <div class="more-btn" v-if="this.jp_more === 'N'">
                <span>더보기</span> <i class="bi bi-chevron-down"></i>
              </div>
              <div class="more-btn" v-else>
                <span>접기</span> <i class="bi bi-chevron-up"></i>
              </div>
            </div>
            <div class="more-wrap more-jp" v-else></div>
 
          </div>
        </div>
      </div>
    </section>
 
  </div>
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      transportList: [],              //선택가능한 교통편정보
      spToDt: {},                     //선박운항지
      dt: "",                         //상품카테고리(선박도착지)
      tr: "",                         //상품카테고리(선박코드)
      mbCode: "",                     //판매상품의 교통수단코드
      nt: "",                         //상품카테고리(국가기준)
      ar: "",                         //상품카테고리(지역기준)
      
      //productListForSales_org: [],    //로컬전체상품
      productListForSales: [],        //판매상품리스트
      ndaytirpList_jp: [],            //일본행 선박상품리스트
      ndaytirpList_jp_org: [],
      ndaytirpList_jp_more: [],
      jp_more: "N",                   //일본내 더보기

      sellerCode: "NT",               //판매자코드


      natName: "",                      //표시페이지 국가명
      selectableNation: [],             //선택가능 국가

      // n1: "",                        //bannerName1
      // n2: "",                        //bannerName2
      nationList: {},                   //여행지역리스트
      pdtCatList: {},                   //상품카테고리
      
      productListForSales_recomend: {}, //추천상품리스트
    };
  },
  created() {
    // 페이지생성과 동시에 리스트정보를 get
		this.dt = (this.$route.query.dt == undefined) ? "%" : this.$route.query.dt;     //도착지코드(운항지코드)
    this.tr = (this.$route.query.tr == undefined) ? "%" : this.$route.query.tr;     //선박코드
    //console.log("this.dt:", this.dt, ", this.tr:", this.tr)
    
    // 유저디바이스체크 (모바일처리용)
    if (this.$isMobile()) 
    {
      this.mobileDisplay = true;
    } 
    else 
    {
      this.mobileDisplay = false;
    }
    this.getProductList_new()
    this.getTransportInfo()

    //this.getProductList();
  },
  mounted() {
    // 구동환경 체크
    if (window.Nachocode.env.isApp()) 
    {
      this.isApp = true;
      //console.log('isApp:', this.isApp);
    }
    else 
    {
      this.isApp = false;
      //console.log('isApp:', this.isApp);
    }
    // if(document.referrer == "") {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   //this.$router.push({path: '/'});
    //   location.replace("/");
    // }

    //dom이 모두 로딩 된 후, 펑션호출
    window.onload = () => {
      this.$nextTick(() => {
        this.scrollToSection();
      });
    };

  },
  computed: {
    user() {
      // 리턴정보가 바뀔 때마다 user()안에 넣어준다
      // 로그인전: bId정보없음, 로그인후: bId정보있음
      return this.$store.state.user;
    }
  },  
  methods: {
    scrollToSection() {
      const element = document.getElementById(this.dt);
      if (element) 
      {
        const offset = 180; // 조정하고자 하는 픽셀값
        window.scrollTo({
          top: element.offsetTop - offset,
          behavior: 'smooth'
        });
      }
      // if (element) {
      //   element.scrollIntoView({ behavior: 'smooth', block: 'start', inline:'nearest' });
      // }
    },

    //선택가능한 선박
    async getTransportInfo() {
      //선박상품용 변수
      let ctCode = "SHP"
      let uFlag = "Y"
      let rtCode = "JP"

      let transportList = await this.$api("/api/transportList", {param: [
          ctCode, uFlag, rtCode
      ]})

      let spToDt = {}

      if(transportList.length > 0)
      {
        //console.log("transportList:", transportList)
        this.transportList = transportList
        //운항지별로 정리
        transportList.forEach(item => {
          if(!spToDt[item.dtCode])
          {
            spToDt[item.dtCode] = [];
          }
          spToDt[item.dtCode].push({
            dtCd: item.dtCode,            //운항지코드
            trCd: item.transCode,         //선박코드
            DT: item.destName,            //운항지명
            TR: item.transName            //선박명
          })
        })
      }
      this.spToDt = spToDt
      //console.log("spToDt:", this.spToDt)
    },

    // 신가격정책이 적용된 상품리스트
    async getProductList_new() 
    {
      //let ntCd = this.nt
      let dtCd = this.dt    //선박도착지 (-> arCd)
      let trCd = this.tr    //선박코드 (-> mbCd1)
      //let sRoute = "F";

      //let arCd = this.ar
      // let sMinPrice = 0;
      // let sMargin = 0;

      //console.log("ntCd:",ntCd);

      // 전체 선박상품 추출 후, 연계상품제외
      let productListForSales_tmptmp = await this.$api("/api/productPrcInfo_m_new", {});
      
      let productListForSales_tmp = productListForSales_tmptmp.filter((item) => {
        // return (item.salesRoute == sRoute)
        return (item.pdtCate && item.pdtCate.includes('F'))
      })      
      
      if(productListForSales_tmp.length > 0) 
      {
        this.productListForSales_org = productListForSales_tmp    //로컬전체상품(org)
      }
      
      //console.log("productListForSales_org: ", this.productListForSales_org)

			this.productListForSales = this.productListForSales_org;
      //console.log("productListForSales: ", this.productListForSales )

      //일본여행 선박상품
      //let ndaytirpList_jp = [];
      let ndaytirpList_jp = this.productListForSales.filter(item => {
        return item.ntCd == 'JP'
      })
      //console.log("ndaytirpList_jp:::::::",ndaytirpList_jp)

      this.ndaytirpList_jp_org = ndaytirpList_jp.slice(0,6)
      this.ndaytirpList_jp_more = ndaytirpList_jp

      //전체선박상품
      // if((ntCd == "%" || ntCd == ""))
      // {
      //   this.ndaytirpList_jp = ndaytirpList_jp.slice(0,6)
      //   return; //이후 조건에 따라 값이 배열값이 덮어써지는 것을 막는다
      // }
      //선박상품 전체선택
      if((dtCd == "%" && trCd == "%"))
      {
        this.ndaytirpList_jp = ndaytirpList_jp.slice(0,6)
        return; //이후 조건에 따라 값이 배열값이 덮어써지는 것을 막는다
      }
      
      if(dtCd != "" && trCd == "")   //일본내 특정지역
      {
        ndaytirpList_jp = this.productListForSales.filter(item => {
          return (item.arCd === dtCd)
        })

        this.ndaytirpList_jp = ndaytirpList_jp.slice(0,6)
      }
      if(dtCd != "" && trCd != "")   //특정선박
      {
        ndaytirpList_jp = this.productListForSales.filter(item => {
          return (item.arCd == dtCd && item.mbCd1 == trCd)
        })
        this.ndaytirpList_jp = ndaytirpList_jp.slice(0,6)
        //this.ndaytirpList_etc = ndaytirpList_etc.slice(0,6)
      }
        //dom요소가 모두 로드된 후 펑션호출
        this.$nextTick(() => {
          this.scrollToSection(this.nt);
        });
    },

    // 상품문의
    inquiryProduct(pCode, sRoute) {
      this.$router.push({path: '/inquiryProduct', query: {productId: pCode, salesRoute:sRoute}});
    },

    //일본내 상품 더보기처리
    showJpMoreList() {
      this.jp_more = (this.jp_more === 'Y') ? "N" : "Y"
      if(this.jp_more === "N")
      {
        this.ndaytirpList_jp = this.ndaytirpList_jp_org
      }
      else
      {
        this.ndaytirpList_jp = this.ndaytirpList_jp_more
      }
    },

    showJpSelArea(param) {
      if(param === 'jpAll') 
      {
        document.querySelector('.more-jp').style.display = 'block'
        document.querySelector('.more-jp').classList.add('initial-state');
        this.ndaytirpList_jp = this.ndaytirpList_jp_more
      }
      else
      {
        document.querySelector('.more-jp').style.display = "none"
        this.ndaytirpList_jp = this.ndaytirpList_jp_more.filter(item => {
          return item.arCd === param
        })
      }
    },


    async getNationList() 
    {
      let nationList = await this.$api("/api/nationList", {});
      this.nationList = nationList;
      
      let natName = nationList.filter((item) => {
        return item.baseCode == this.nt
      })
      //this.natName = natName[0].codeNameKor
      this.natName = natName.codeNameKor
      //console.log("nationList:",this.nationList,",natName:",this.natName)
    },

    // mixins에 있는 공통함수 호출샘플
    /** 자릿수 표시 */
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    /** 개행처리 */
    getStringFormat(text) {
      return this.$stringFormat(text);
    },
		/** 일자처리 */
    getDateFormat(date)
    {
      return this.$dateFormat(date);
    },


    goToDetail(productId, salesRoute) {
      this.$router.push({path: '/detail', query: {productId: productId, salesRoute:salesRoute}});
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap');
 
/* ================================================
  # CSS 변수 — 바다 테마 (#sub-ship 하위 전체 상속)
================================================ */
#sub-ship {
  --ocean-deep:    #0a2744;
  --ocean-mid:     #1a5276;
  --ocean-bright:  #1a8fb5;
  --ocean-light:   #38bdf8;
  --foam:          #e0f7ff;
  --foam-soft:     #f0f9ff;
  --sand:          #f8f5ee;
  --wave-line:     #bae6fd;
  --text-main:     #0d2137;
  --text-sub:      #4a6b82;
  --gray-200:      #e2eef5;
  --gray-400:      #94b3c5;
  --radius-sm:     6px;
  --radius-md:     14px;
  --shadow-sm:     0 2px 10px rgba(10,39,68,0.08);
  --shadow-md:     0 8px 28px rgba(10,39,68,0.14);
 
  background-color: var(--foam-soft);
}
 
@media (min-width: 991px) {
  #sub-ship { margin-top: -6rem; }
}
 
.fingerPointer { cursor: pointer; }
 
 
/* ================================================
  # 히어로 캐러셀
================================================ */
.hero-img {
  width: 100%;
  height: 30rem;
  object-fit: cover;
  filter: brightness(0.88);
}
.hero-img-pc {
  height: 50rem;
}
 
/* 인디케이터 */
#sub-ship .carousel-indicators [data-bs-target] {
  width: 24px;
  height: 3px;
  border-radius: 2px;
  background: rgba(255,255,255,0.5);
  border: none;
  opacity: 1;
  transition: all 0.3s;
}
#sub-ship .carousel-indicators .active {
  width: 44px;
  background: var(--ocean-light);
}
 
/* 화살표 숨김 */
#sub-ship .carousel-control-prev,
#sub-ship .carousel-control-next { opacity: 0; }
 
/* 캡션 */
.hero-caption {
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  padding: 0 !important;
  text-align: left;
  background: linear-gradient(
    to top,
    rgba(10, 39, 68, 0.80) 0%,
    rgba(10, 39, 68, 0.20) 60%,
    transparent 100%
  );
}
.caption-inner {
  padding: 2.5rem 4rem 3.5rem;
}
.caption-tag {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 3px;
  color: var(--ocean-light);
  margin-bottom: 0.6rem;
  text-transform: uppercase;
}
.hero-caption h5 {
  font-family: 'Black Han Sans', sans-serif;
  font-size: 2.7rem;
  color: #fff;
  margin-bottom: 0.4rem;
  line-height: 1.2;
  text-shadow: 0 2px 16px rgba(0,0,0,0.4);
}
.hero-caption p {
  font-size: 1rem;
  color: rgba(255,255,255,0.85);
  margin: 0;
}
 
@media (max-width: 767px) {
  .caption-inner { padding: 1.5rem 1.5rem 2.5rem; }
  .hero-caption h5 { font-size: 1.7rem; }
  .hero-caption p { font-size: 0.85rem; }
  .caption-tag { font-size: 0.62rem; }
}
 
 
/* ================================================
  # 웨이브 구분선
================================================ */
.wave-divider {
  margin-top: -4px;
  line-height: 0;
  background: var(--ocean-deep);
}
.wave-divider svg {
  width: 100%;
  height: 50px;
  display: block;
}
 
 
/* ================================================
  # 섹션 공통
================================================ */
.packages {
  margin: 4rem 0 5rem;
}
 
 
/* ================================================
  # 섹션 타이틀
================================================ */
#sub-ship .sub-title {
  margin-bottom: 2.2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.title-deco {
  width: 44px;
  height: 44px;
  background: var(--ocean-mid);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.9rem;
  box-shadow: 0 4px 14px rgba(26,82,118,0.3);
}
.title-deco i {
  font-size: 1.3rem;
  color: var(--ocean-light);
}
#sub-ship .sub-title .st-main {
  display: block;
  color: var(--ocean-deep);
  font-size: 1.9rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin-bottom: 0.3rem;
}
#sub-ship .sub-title .st-sub {
  display: block;
  font-size: 0.9rem;
  color: var(--text-sub);
}
 
@media (max-width: 767px) {
  #sub-ship .sub-title .st-main { font-size: 1.5rem; }
}
 
 
/* ================================================
  # 카테고리 필터
================================================ */
#sub-ship .category {
  margin: 0 0 2rem;
}
#sub-ship .category ul {
  padding-left: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 0;
}
#sub-ship .category ul li {
  padding: 7px 20px;
  border: 1.5px solid var(--wave-line);
  border-radius: 50px;
  background: #fff;
  transition: all 0.25s ease;
  cursor: pointer;
}
#sub-ship .category ul li a {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--ocean-mid);
  text-decoration: none;
  transition: color 0.2s;
}
#sub-ship .category ul li:hover {
  background: var(--ocean-mid);
  border-color: var(--ocean-mid);
}
#sub-ship .category ul li:hover a {
  color: #fff;
}
 
@media (max-width: 1024px) {
  #sub-ship .category ul li { padding: 5px 14px; }
  #sub-ship .category ul li a { font-size: 0.82rem; }
}
 
 
/* ================================================
  # 상품 카드
================================================ */
#sub-ship .packages .package-item {
  border-radius: var(--radius-md);
  overflow: hidden;
  background: #fff;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--gray-200);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
#sub-ship .packages .package-item:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
}
 
@media (max-width: 991px) {
  #sub-ship .packages .package-item { margin-bottom: 1.5rem; }
}
 
 
/* 이미지 */
#sub-ship .package-item .pic {
  position: relative;
  overflow: hidden;
}
#sub-ship .package-item .card-img-top {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  transition: transform 0.45s ease;
  display: block;
}
#sub-ship .package-item:hover .card-img-top {
  transform: scale(1.05);
}

/* aspect-ratio를 쓰면 컬럼 폭(3열/2열/1열)에 상관없이 항상 4:3 비율이 유지되므로
   브레이크포인트별 높이 오버라이드가 더 이상 필요 없음 */
 
/* 호버 오버레이 */
#sub-ship .package-item .pic .packages-hover {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(10, 39, 68, 0.55);
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.35s ease;
  top: 0;
  left: 0;
}
#sub-ship .package-item:hover .pic .packages-hover {
  opacity: 1;
}
.hover-cta {
  color: #fff;
  font-size: 0.88rem;
  font-weight: 700;
  letter-spacing: 1px;
  border: 2px solid var(--ocean-light);
  padding: 8px 22px;
  border-radius: 30px;
  background: rgba(56,189,248,0.15);
  transition: background 0.2s;
}
.hover-cta:hover {
  background: var(--ocean-light);
  color: var(--ocean-deep);
}
 
/* 항로 배지 (이미지 위 하단) */
.route-chip {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(10, 39, 68, 0.78);
  color: var(--ocean-light);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 4px 12px;
  border-radius: 20px;
  backdrop-filter: blur(4px);
}
 
 
/* 텍스트 영역 */
#sub-ship .package-item-txt {
  padding: 1rem 1.2rem 1.2rem;
}
 
.pdtName {
  height: 3.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.45;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-main);
  margin-bottom: 0.4rem;
}
.pdtRemarks {
  font-size: 0.82rem;
  color: var(--text-sub);
  /* line-height(1.4) × 2줄 = 2.8em. em 단위라 폰트 크기가 바뀌어도(예: lg 브레이크포인트)
     항상 정확히 2줄 높이만 확보되어 3번째 줄이 삐져나오지 않음 */
  min-height: 2.8em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  margin-bottom: 0;
}
.pdtRemarks i {
  color: var(--ocean-bright);
  margin-right: 3px;
}
 
.card-divider {
  height: 1px;
  background: var(--gray-200);
  margin: 0.8rem 0;
}

/* lg 이상, 좁아진 카드 폭에 맞춰 텍스트 영역도 비율에 맞게 축소 */
@media (min-width: 992px) {
  #sub-ship .package-item-txt {
    padding: 0.85rem 1rem 1rem;
  }
  .pdtName {
    font-size: 0.95rem;
  }
  .pdtRemarks {
    font-size: 0.76rem;
  }
}
 
 
/* ================================================
  # 가격
================================================ */
#sub-ship .packages-content .price { float: none; }
.price-row { align-items: baseline; }
.ndayPrice { color: var(--text-main); }
.price-won { font-size: 0.88rem; color: var(--text-sub); margin-left: 2px; }
.original-price { font-size: 0.88rem !important; }
.discount-rate {
  font-size: 1rem !important;
  font-weight: 800 !important;
  color: #e74c3c !important;
}
.final-price { color: var(--ocean-deep) !important; }
.preparing-wrap { gap: 6px; }
.preparing-text { font-size: 0.9rem !important; font-weight: 600; color: var(--text-sub); }
.mbus-icon { width: 1.8rem !important; height: auto !important; }

/* lg 이상, bootstrap fs-4(1.5rem)가 좁아진 카드에서 과도하게 커 보이지 않도록 축소 */
@media (min-width: 992px) {
  #sub-ship .ndayPrice.fs-4 {
    font-size: 1.2rem;
  }
}
 
 
/* ================================================
  # 뱃지
================================================ */
#sub-ship .badge { text-align: center; }
#sub-ship .badge .badge1 {
  position: absolute;
  top: 0;
  left: 0;
  background: #e74c3c;
  opacity: 0.88;
  padding: 10px 14px;
  width: 150px;
  border-radius: 0 0 var(--radius-sm) 0;
}
#sub-ship .badge .badge1 .badge1-text {
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  padding: 0;
}
#sub-ship .badge .badge2 {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255,255,255,0.92);
  padding: 10px 14px;
  width: 150px;
  border-radius: 0 0 var(--radius-sm) 0;
}
#sub-ship .badge .badge2 .badge2-text {
  color: var(--ocean-deep);
  font-size: 1rem;
  font-weight: 700;
  padding: 0;
}

/* lg 이상, 좁아진 이미지 폭에 맞춰 뱃지도 비율에 맞게 축소 (150px * 2/3 ≈ 120px) */
@media (min-width: 992px) {
  #sub-ship .badge .badge1,
  #sub-ship .badge .badge2 {
    width: 120px;
    padding: 8px 10px;
  }
  #sub-ship .badge .badge1-text,
  #sub-ship .badge .badge2-text {
    font-size: 0.85rem;
  }
}
 
 
/* ================================================
  # 더보기 버튼
================================================ */
.more-wrap {
  display: flex;
  justify-content: center;
  margin: 2.5rem 0 1rem;
}
.more-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 11px 38px;
  border: 1.5px solid var(--ocean-mid);
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--ocean-mid);
  cursor: pointer;
  transition: all 0.25s ease;
  background: #fff;
}
.more-btn:hover {
  background: var(--ocean-mid);
  color: var(--ocean-light);
  border-color: var(--ocean-mid);
}
</style>